const makeInitialState = (contract, balance) => {
  return {
    contractId: contract.id,
    balance,
    clientName: contract.clientName,
    clientId: contract.clientId,
    clientPersonType: contract.clientPersonType,
    equipmentId: contract.equipmentId,
    equipmentBrand: contract.equipmentData.brand,
    equipmentModel: contract.equipmentData.model,
    cededClientName: null,
    cededClientPersonType: null,
    cededClientId: null,
    cedeDate: null,
    createdAt: null,
    startDate: null,
    endDate: contract.endDate,
    firstRent: null,
    includeClientAddress: false,
    configuredEquipmentLocation: false,
    avals: [],
    sendToDigitalSign: false
  };
};

export default makeInitialState;
